export default {
  name: 'CompanyTypesMixin',
  methods: {
      companyNameHelperFunction : function(companyType) {
          if(companyType == 'other') return 'Andere'
          else if(companyType == 'consultancy') return 'Diensten'
          else if(companyType == 'retail') return 'Retail'
          else if(companyType == 'maak') return 'Maakbedrijf'
          else if(companyType == 'zorg') return 'Zorgbedrijf'
          else if(companyType == 'algemeen') return 'Algemeen'
          else return "Onbekend"
      }
  }
}
